var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-explicit-any */
import Styles from './select-kv-styles.scss';
import React, { useRef } from 'react';
import cssnames from 'classnames';
const SelectKVBase = (_a) => {
    var { state, setState, errorSpan, customSelectClass } = _a, props = __rest(_a, ["state", "setState", "errorSpan", "customSelectClass"]);
    const selectRef = useRef();
    const error = state[`${props.name}Error`];
    const isFormDirty = state.dirtyFields ? state.dirtyFields[props.name] : true;
    const changeValue = (e) => {
        e.preventDefault();
        setState(Object.assign(Object.assign({}, state), { [e.target.name]: e.target.value, dirtyFields: Object.assign(Object.assign({}, state.dirtyFields), { [e.target.name]: true }) }));
    };
    const LabelSelect = () => {
        return (React.createElement("label", { className: props.label ? Styles.labelSelect : Styles.labelPlaceholder, "data-testid": `${props.name}-label`, onClick: () => {
                if (!props.label)
                    selectRef.current.focus();
            }, title: error },
            props.label ? props.label : props.placeholder,
            " ",
            props.required && React.createElement("span", { style: { color: '#FFA800' } }, "*")));
    };
    return (React.createElement("div", { "data-testid": `${props.name}-wrap`, className: Styles.selectWrap, "data-status": error && isFormDirty ? 'invalid' : 'valid' },
        props.label && React.createElement(LabelSelect, null),
        React.createElement("select", Object.assign({ className: cssnames({
                [Styles.selectError]: errorSpan
            }, customSelectClass) }, props, { ref: selectRef, title: error, placeholder: props.label ? props.placeholder : ' ', "data-testid": props.name, onChange: changeValue })),
        errorSpan && React.createElement("span", { className: Styles.spanError }, errorSpan)));
};
export default SelectKVBase;
